<template>
  <div>
    <Line :data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'vue-chartjs';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  Tooltip,
  Legend,
);

export default {
  extends: Line,
  components: {
    Line,
  },
  props: {
    dados: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartData: {
        labels: this.dados.dailyRemainingWork.map((item) =>
          this.formatDate(item.data),
        ),
        datasets: [
          {
            label: 'Trabalho Restante',
            data: this.dados.dailyRemainingWork.map(
              (item) => item.trabalhoRestante,
            ),
            backgroundColor: 'rgba(42, 52, 161, 0.2)',
            borderColor: '#2a34a1',
            fill: false,
            tension: 0.1,
          },
          {
            label: 'Trabalho Ideal',
            data: this.dados.idealLine.map((item) => item.trabalhoIdeal),
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: '#ff6384',
            fill: true,
            borderDash: [5, 5],
            tension: 0.1,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            title: {
              display: true,
              text: 'Data',
              font: {
                weight: 'bold',
              },
            },
          },
          y: {
            title: {
              display: true,
              text: 'Trabalho Restante (Story Points)',
              font: {
                weight: 'bold',
              },
            },
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
          },
        },
        plugins: {
          legend: {
            display: true,
            position: 'top',
          },
          tooltip: {
            callbacks: {
              label: (context) =>
                `Trabalho Restante: ${context.raw} Story Points`,
            },
          },
        },
      },
    };
  },
  methods: {
    formatDate(date) {
      return date.split('-').join('/');
    },
  },
};
</script>
